module.exports = __webpack_public_path__ + "static/bg.ab7e3c80.png";